/** Die gemeinsame Schale der beiden Plattform-Bildschirme; siehe `me/route.tsx`. */
import { Outlet, createFileRoute } from '@tanstack/react-router'
import type { ReactElement } from 'react'
import { RequireSession } from '../../auth'

export const Route = createFileRoute('/admin')({
  component: AdminSchale,
})

function AdminSchale(): ReactElement {
  return (
    <RequireSession>
      <Outlet />
    </RequireSession>
  )
}
